export const shortAddress = (str = '', limit = 4) => `${str.slice(0, limit)}…${str.slice(-limit)}`;
